import { render, staticRenderFns } from "./SmtpSettings.vue?vue&type=template&id=20c97e4c&scoped=true&"
import script from "./SmtpSettings.vue?vue&type=script&lang=js&"
export * from "./SmtpSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmtpSettings.vue?vue&type=style&index=0&id=20c97e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c97e4c",
  null
  
)

export default component.exports